import useSWR from 'swr';

import myShopClient from '@services/nearlive';

/**
 * SWR-backed channel definitions catalogue, from `/api/channels/definitions`.
 *
 * The definitions are static platform config (titles, descriptions, pricing,
 * requirements, icons, cover images) — they never change per shop — so the
 * key is shared across the dashboard and revalidation on focus is off.
 *
 * Returns `definitions` as an object keyed by channel id (`{}` until resolved).
 */
export function useChannelDefinitions() {
	const { data, error, isLoading } = useSWR(
		'unify:channel-definitions',
		async () => {
			const client = await myShopClient();
			const { data } = await client.get('/api/channels/definitions');
			return data;
		},
		{ revalidateOnFocus: false }
	);
	return { definitions: data && typeof data === 'object' ? data : {}, error, isLoading };
}
